import { render, staticRenderFns } from "./PcsLogo.vue?vue&type=template&id=212a593a"
import script from "./PcsLogo.vue?vue&type=script&lang=js"
export * from "./PcsLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports